import { PromptTemplate } from '../types';

export const taskPrompt: PromptTemplate = {
  type: 'task',
  template: `First, provide a helpful conversational response that:
1. Acknowledges the user's request naturally
2. Explains why creating a task would be beneficial for their goal
3. Provides context about task management best practices or relevant insights

Then, if you believe the user wants a task recommendation, include this structured format below your conversational response:

---RECOMMENDATION---
TASK TITLE: [clear, actionable title]
TASK DESCRIPTION: [detailed description including specific steps or context]
---END RECOMMENDATION---

Provide both the conversational response AND the structured recommendation in a single response. The conversational part maintains natural dialogue flow while the structured part enables action card creation.

OR if you need extra context to provide the perfect recommendation, continue chatting conversationally without the structured format.`,
  validation: {
    requiredFields: ['TASK TITLE', 'TASK DESCRIPTION'],
    stopKeywords: ['---RECOMMENDATION---', '---END RECOMMENDATION---'],
    maxRecommendations: 1
  }
}; 